/**
 * AgentBulletList - Simple bullet list for agent visualizations
 */

import React from 'react';
import { cn } from '../../../lib/utils';
import { BulletListVisualization } from './types';

interface AgentBulletListProps {
  data: BulletListVisualization;
  className?: string;
}

export const AgentBulletList: React.FC<AgentBulletListProps> = ({ data, className }) => {
  const { title, items } = data;

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className={cn("w-full", className)}>
      {title && (
        <h4 className="text-sm font-medium mb-2 text-foreground">{title}</h4>
      )}
      <ul className="space-y-1.5">
        {items.map((item, index) => (
          <li
            key={index}
            className="flex items-start gap-2 text-sm text-foreground"
          >
            <span className="text-muted-foreground mt-1.5">•</span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
